import * as z from "zod";

export const toggleDynamicCoverageTransformFunction = {
  name: "toggleDynamicCoverageTransformFunction" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.object({ isEnabled: z.boolean() }),
};
